export const SimplifiedErrandButtonTags = {
    Delspara: 'Delsparat',
    Inrapporterat: 'Inrapporterat',
    AvvaktaCanceranmalan: 'Avvakta canceranmälan',
    ForGodkannande: 'För godkännande',
    Remiss: 'Remiss',
    Paminnelse: 'Påminnelse',
    Komplettera: 'Komplettera'
};
export const LOCKED_SYSTEM_TAGS = [
    SimplifiedErrandButtonTags.Delspara,
    SimplifiedErrandButtonTags.Inrapporterat
];
export const DEFAULT_TAG_SORTORDER = [
    SimplifiedErrandButtonTags.Delspara,
    SimplifiedErrandButtonTags.Komplettera,
    SimplifiedErrandButtonTags.Paminnelse,
    SimplifiedErrandButtonTags.ForGodkannande,
    SimplifiedErrandButtonTags.AvvaktaCanceranmalan,
    SimplifiedErrandButtonTags.Remiss,
    SimplifiedErrandButtonTags.Inrapporterat
];
